import CardsList from "@/components/cardsList";
import { PlainHoverEffect } from "styles/hoverPresets";
import { CSPM_WORKS_CONSTANTS } from "./constants";

const WorkComp = () => {
  return (
    <CardsList
      columns={{ base: 1, sm: 2, md: 4 }}
      title={CSPM_WORKS_CONSTANTS.title}
      list={CSPM_WORKS_CONSTANTS.list}
      spacing={{ base: 8, md: 12 }}
      hoverEffect
      hover={PlainHoverEffect}
    />
  );
};

export default WorkComp;
